/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars } from './util.js';
import { getFromSession, setInSession } from './session-util.js';
import { getPreferedMaxDialogWidth } from './dialog-util.js';
import { getFromBackend, default_ajax_error_handler } from './fetch-util.js';

import { jQuery } from '../other/jquery-hooked.js';

import { MTemplates } from './templates.js';
import { Lightbox } from './lightbox.js';
import { MVResult } from './result.js';
import { MVSearch } from './search.js';


export let MVSortOptions = function($) {

	var m_sort_option_groups = null;

	function _open2() {
		var dlg = $('#media-sort-form');

		$('#media-sort-form form').off().submit( function() {
			setInSession( 'view_sort', $('input[id^=view-sort-]:checked',dlg).attr('value') );
			var result_view_list_type = MVResult.getWidget().getWrappedListType();
			if( result_view_list_type==='lightbox' ) Lightbox.go();
			else MVSearch.triggerFilter();
			dlg.dialog('destroy');
			return false;
		} );

		function rfun( e, win_w, win_h ) {
			if( dlg.hasClass('ui-dialog-content') && dlg.dialog('isOpen') ) {
				var dlg_w = Math.min(getPreferedMaxDialogWidth()-40,480);
				var dlg_h = 'auto';
				dlg.dialog('option',{'width':dlg_w,'height':dlg_h});
				if( dlg.height() > win_h-60 ) {
					var xdlg_h = win_h-20;
					dlg.dialog('option',{'width':dlg_w,'height':xdlg_h});
				}
			}
		}

		$('#media-sort-form').dialog('destroy').dialog( {
			width:Math.min(getPreferedMaxDialogWidth()-40,480),
			height:'auto',
			modal:true,
			resizable:false,
			position:{my:'center',at:'center',of:window,'collision':'flip fit'},
			open: function(ev,ui) {
				rfun( null, $(window).width(), $(window).height() );
				var vs = getFromSession('view_sort');
				$('input[id^=view-sort-]',dlg).each( function() {
					if( $(this).attr('value')==vs ) {
						$(this).prop('checked',true).focus();
						return false;
					}
				} );
			},
			close: function(ev,ui) {
				$(document).off('mjswinresize.MediaSortForm');
				$(this).dialog('destroy');
			},
		} ).show();

		$(document)
			.off('mjswinresize.MediaSortForm')
			.on('mjswinresize.MediaSortForm', $.debounce( 250, rfun ) );
	}

	function _build_sort_options_html() {
		var html = '';
		for( var g=0; g<m_sort_option_groups.length; ++g ) {
			var sog = m_sort_option_groups[g];
			//sog.title, sog.options
			if( sog.two_columns ) html += '<div class="checkbox-group-hsplitter">';
			html += '<div class="checkbox-group"><b>'+htmlspecialchars(sog.title)+'</b><br />';
			for( var o=0; o<sog.options.length; ++o ) {
				var so = sog.options[o];
				html +=	 '<span class="cb-item">';
				html += '<input id="view-sort-'+so.id+'" type="radio" name="view_sort" value="'+htmlspecialchars(so.sort,true,true)+'" />';
				html += '<label for="view-sort-'+so.id+'"> '+htmlspecialchars(so.title)+'</label>';
				html += '</span>';
				html += '<br />';
			}
			html += '</div>';
			if( sog.two_columns ) html += '</div>';
		}
		$('#media-sort-form-options').html(html);
	}

	function open() {
		if( m_sort_option_groups===null ) {
			getFromBackend( 'json/widgets/config-sort_options', '', true, function(j) {
				if( j && j.success ) {
					m_sort_option_groups = j.sort_option_groups;
					_build_sort_options_html();
					_open2();
				}
			}, function _timeout() {
				default_ajax_error_handler(null,'timeout');
			}, function _error(jqXHR,textStatus,message) {
				default_ajax_error_handler(jqXHR,textStatus,message);
			}, true );
		} else {
			_open2();
		}
	}

	return {
		open: MTemplates.queryDialogHTMLWrappedFn('form_media_sort',open),
	};
}(jQuery); // namespace MVSortOptions
